/**
 * @generated SignedSource<<5abb97ae284ebc2c3268de369f7ffee6>>
 * @relayHash 68327ba776ce56cb0623677e9ba724ce
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 68327ba776ce56cb0623677e9ba724ce

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type CreateExamVersionInput = {
  clientMutationId?: string | null;
  examId: string;
};
export type adminCreateVersionMutation$variables = {
  input: CreateExamVersionInput;
};
export type adminCreateVersionMutation$data = {
  readonly createExamVersion: {
    readonly examVersion: {
      readonly id: string;
    };
  } | null;
};
export type adminCreateVersionMutation = {
  response: adminCreateVersionMutation$data;
  variables: adminCreateVersionMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CreateExamVersionPayload",
    "kind": "LinkedField",
    "name": "createExamVersion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ExamVersion",
        "kind": "LinkedField",
        "name": "examVersion",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "adminCreateVersionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "adminCreateVersionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "68327ba776ce56cb0623677e9ba724ce",
    "metadata": {},
    "name": "adminCreateVersionMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "883464d735052a8c8c558e63f51146e5";

export default node;
